import { makeAutoObservable } from 'mobx';
import JSZip from 'jszip';
import { editProfileStore } from '../editProfile/editProfile.store';
import { editAvatarStore } from '../editAvatar/editAvatar.store';
import { globalStore } from '../../global.store';
import { myAssetsStore } from '../myAssets/myAssets.store';
import { qualityStore } from '../quality/quality.store';
import { ActionType } from './actionpanel.type';
import { unityheaderStore } from '../unityheader/unityheader.store';

//   const { setShowEditAvatarPopup, setAvatarEditor } = editAvatarStore;

class Actionpanel {
  actionsListStatus = false;

  actionsList: Array<ActionType> = [
    {
      id: 1,
      title: 'edit profile',
      action: () => this.editProfileAction(),
    },
    {
      id: 2,
      title: 'edit avatar',
      action: () => this.editAvatarAction(),
    },
    {
      id: 3,
      title: 'download avatar',
      action: () => this.downloadAvatarAction(),
    },
    {
      id: 4,
      title: 'my spaces',
      action: () => this.mySpacesAction(),
    },
    // {
    //     id: 4,
    //     title: "my assets",
    //     action: () => this.myAssetsAction()
    // },
    {
      id: 5,
      title: 'quality settings',
      action: () => this.qualitySettingsAction(),
    },
    // {
    //     id: 6,
    //     title: "connect wallet",
    //     action: () => { }
    // }
  ];

  constructor() {
    makeAutoObservable(this);
  }

  setActionsListStatus = (status: boolean) => {
    this.actionsListStatus = status;
  };

  editProfileAction = () => {
    editProfileStore.setShowEditProfilePopup(true);
    this.setActionsListStatus(false);
  };

  editAvatarAction = () => {
    editAvatarStore.setAvatarEditor('rpm');
    this.setActionsListStatus(false);
  };

  downloadAvatarAction = () => {
    const files: any[] = [
      {
        name: 'avatarGlb.glb',
        url: globalStore.userData.readyPlayerMeAvatar,
      },
      {
        name: 'avatarImage.png',
        url: `${globalStore.userData.readyPlayerMeAvatarImage}?camera=fullbody`,
      },
    ];
    const zip = new JSZip();
    const folder = zip.folder('avatarData') as JSZip;
    // Add images to folder
    files.forEach((file) => {
      const blob = fetch(file.url).then((res) => res.blob());
      folder.file(file.name, blob, { binary: true });
    });

    // Zip folder and download folderZip
    zip
      .generateAsync(
        { type: 'blob', streamFiles: true },
        async (metadata: any) => {
          actionpanelStore.actionsList[2].title = `download avatar ${metadata.percent ? `${metadata.percent.toFixed(1)}%` : ''}`;
        },
      )
      .then((blob: any) => {
        actionpanelStore.actionsList[2].title = 'download avatar';
        unityheaderStore.saveBlob()(blob, 'avatarData.zip');
      });
  };

  mySpacesAction = () => {
    globalStore.navigation('myspaces');
    this.setActionsListStatus(false);
  };

  myAssetsAction = () => {
    myAssetsStore.setShowMyAssetsPopup(true);
    this.setActionsListStatus(false);
  };

  qualitySettingsAction = () => {
    qualityStore.setShowQualityPopup(true);
    this.setActionsListStatus(false);
  };

  removeState() {}
}
export const actionpanelStore: Actionpanel = new Actionpanel();
